module.exports = __webpack_public_path__ + "static/media/rails.251beda2.svg";